module.exports = __webpack_public_path__ + "static/media/finance-interest-charged.9ee8a2ee.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/finance-interest-charged.mp4
// module id = 2578
// module chunks = 0